import { InputBase } from "@mui/material";
import { RoundedBlackBoundary } from "./Containers";
import SearchIcon from '@mui/icons-material/Search';

const SearchInputComponent = ({ width, placeholder, value, valueHandler }) => {
    const style = { width: width ? `${width}ch` : 'auto' };
    return <InputBase value={value ? value : ''} onChange={(e) => valueHandler(e.target.value)} placeholder={placeholder} sx={style} />
}

export default function Search({ search, handleSearch, placeholder, maxWidth }) {
    return (
        <RoundedBlackBoundary>
            <SearchIcon fontSize="small"/>
            <SearchInputComponent width={maxWidth} placeholder={placeholder} value={search} valueHandler={handleSearch} />
        </RoundedBlackBoundary>
    );
}